'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMRequiredLabel = function WMRequiredLabel(_ref) {
	var label = _ref.label,
	    required = _ref.required,
	    valid = _ref.valid,
	    colorsFixed = _ref.colorsFixed;
	return _react2.default.createElement(
		'span',
		null,
		_react2.default.createElement(
			'span',
			{
				style: colorsFixed ? _styles2.default.fixedLabelColor : {},
				'data-component-identifier': 'configurable-label__label-text'
			},
			label
		),
		required && _react2.default.createElement(
			'span',
			{
				'data-component-identifier': 'configurable-label__asterisk',
				style: _extends({}, _styles2.default.asterisk(valid), colorsFixed ? _styles2.default.fixedAsterixColor : {})
			},
			' *'
		)
	);
};

exports.default = WMRequiredLabel;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMRequiredLabel/index.js